import React, {Component} from 'react';

import { InputGroup, InputGroupText, Input } from 'reactstrap';

import './styles.css';

class SearchASN extends Component {
    constructor(props) {
        super(props)

        this.state= {
            purchaseOrderNumber: '',
            dcId: '',
            vendorId: '',
            itemId: '',
            filterByItem: '',
            filterByVendor: ''
        }
    }

    handlePOChange = (e) => {
        let purchaseOrderNumber = e.target.value;
        this.setState({purchaseOrderNumber: purchaseOrderNumber});
    }

    handleDCChange = (e) => {
        let dcId = e.target.value;
        this.setState({dcId: dcId});
    }

    handleVendorChange = (e) => {
        let vendorId = e.target.value;
        this.setState({vendorId: vendorId});
    }

    handleItemChange = (e) => {
        let itemId = e.target.value;
        this.setState({itemId: itemId});
    }

    keyPressedItem = (e) => {
        const key = e.key;   
        if(key === 'Enter') {
            this.props.data(this.state);
        }
    }

    handleFilterByItemChange = (e) => {
        let item = e.target.value;
        this.setState({filterByItem: item});
        this.props.filterByItem(item);
    }

    handleFilterByVendorChange = (e) => {
        let vendor = e.target.value;
        this.setState({filterByVendor: vendor});
        this.props.filterByVendor(vendor);
    }
    

    render() {
        return (
            <div>
                 <div className="search-bar">
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >PO Number</InputGroupText>
                        </InputGroupText>
                        <Input   onChange={this.handlePOChange}  value={this.state.purchaseOrderNumber} onKeyPress={e => {this.keyPressedItem(e)}}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >DC</InputGroupText>
                        </InputGroupText>
                        <Input   onChange={this.handleDCChange}  value={this.state.dcId} onKeyPress={e => {this.keyPressedItem(e)}}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Vendor</InputGroupText>
                        </InputGroupText>
                        <Input onChange={this.handleVendorChange}  value={this.state.vendorId} onKeyPress={e => {this.keyPressedItem(e)}}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Item</InputGroupText>
                        </InputGroupText>
                        <Input  onChange={this.handleItemChange}  value={this.state.itemId} onKeyPress={e => {this.keyPressedItem(e)}} />
                    </InputGroup>
                </div>
                <div className="search-bar">
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Filter by Item</InputGroupText>
                        </InputGroupText>
                        <Input  onChange={this.handleFilterByItemChange}  value={this.state.filterByItem} readOnly={this.props.isData}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Filter by Vendor</InputGroupText>
                        </InputGroupText>
                        <Input  onChange={this.handleFilterByVendorChange}  value={this.state.filterByVendor} readOnly={this.props.isData}/>
                    </InputGroup>
                </div>
            </div>
        );
    }
    
}

export default SearchASN;